import React from 'react';
import { Tooltip } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import summary from "../../src/assets/images/main_images/organization-summerize.svg"
import supportReport from "../../src/assets/images/main_images/support-report.svg"
import sale from "../../src/assets/images/main_images/sale.svg"
import marketerBalanceReport from "../../src/assets/images/main_images/marketer-balance-report.svg"
import accountMarketerTurnover from "../../src/assets/images/main_images/account-marketer-turnover.svg"
import notifications from "../../src/assets/images/main_images/notifications.svg"
import openTickets from "../../src/assets/images/main_images/open-tickets.svg"
import closeTickets from "../../src/assets/images/main_images/close-tickets.svg"
import payMarketers from "../../src/assets/images/main_images/pay-marketers.svg"
import requestsInprogress from "../../src/assets/images/main_images/requests-inprogress.svg"
import rejectedRequests from "../../src/assets/images/main_images/rejected-requests.svg"
import userManagement from "../../src/assets/images/main_images/userManagement.svg"
import marketerImg from "../../src/assets/images/main_images/marketer.png";
import businessesManagement from "../../src/assets/images/main_images/businessesManagement.svg"
import installmentImages from "../../src/assets/images/main_images/installment.webp"
import blogManagement from "../../src/assets/images/main_images/blogManagement.svg"
import seoManagement from "../../src/assets/images/main_images/seoManagement.svg"
import CompanyFeedback from "../../src/assets/images/main_images/widget-img.png"
import ExternalLoginPng from "../../src/assets/images/main_images/external-login.png"
import EditDesign from "../../src/assets/images/main_images/edit-design.svg"
import BusinessAdmin from "../../src/assets/images/main_images/business-admin.svg"
import RenewalReport from "../../src/assets/images/main_images/RenewalReport.png"
import businesscompanySaleReport from "../../src/assets/images/main_images/companySaleReport.png"
import BusinessPendingPayment from "../../src/assets/images/main_images/BusinessPendingPayment.svg"
import receiptIcon from "../../src/assets/images/receipt.png"
import { usePersistedStore } from '../store/persisted-store';
import { useView } from '../hooks/useView';
import { GRID_COLS_TO_LG_CLASS } from './GridSizeToggle';

const PERSIAN_DIGITS = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
const toPersianDigits = (value) => String(value).replace(/[0-9]/g, (d) => PERSIAN_DIGITS[d]);

const PinIcon = () => (
    <svg className="qa-pin-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 3H7a2 2 0 0 0-2 2v16l7-3.5 7 3.5V5a2 2 0 0 0-2-2z" />
    </svg>
);

const PinButton = ({ isPinned, onToggle }) => (
    <Tooltip title={isPinned ? 'حذف از دسترسی سریع' : 'افزودن به دسترسی سریع'}>
        <button
            type="button"
            className={`qa-pin ${isPinned ? 'qa-pin--active' : ''}`}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onToggle();
            }}
        >
            <PinIcon />
        </button>
    </Tooltip>
);

const ToolCard = ({ item, isPinned, onTogglePin, onNavigate, colClass }) => (
    <div className={colClass}>
        <Link to={item.path} onClick={onNavigate}>
            <div className="card qa-card">
                <PinButton isPinned={isPinned} onToggle={onTogglePin} />
                <div className="card-body">
                    <div className="row">
                        <div className="mainContent-rectangle-parent-img">
                            <img src={item.icon} alt={item.id} className="mainContent-img" />
                        </div>
                    </div>
                    <div className="row title-rectangle-img">
                        <div className="col-12">
                            <div>
                                <h4 className="text-muted font-weight-medium mb-0">{item.label}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    </div>
);

const MainContent = ({ onPageTile, hasTicketingService, isMarketer, searchTerm = '', gridCols = 4, selectedCategory = 'all' }) => {
    const { isMobile, isTablet } = useView();
    const { auth, business, isQuickAccess, toggleQuickAccess } = usePersistedStore()
    const userResources = auth?.userInfo?.Resources;
    const username = auth?.userInfo?.UserName;
    const updateBusinessResource = userResources?.includes("UpdateBusiness")
    const location = useLocation();
    const url = location.pathname.split('/')[1];
    const handlePageTitle = (title) => {
        onPageTile(title);
    }

    const currentBusiness = business?.currentBusiness;
    const data = currentBusiness?.data;
    const businessType = data?.type
    const businessId = data?.id

    const hasRes = (res) => !!userResources?.includes(res);

    const toolItems = [
        { id: 'users', icon: userManagement, label: 'مدیریت کاربران', path: `/${url}/users/1`, visible: hasRes('UserManagment'), category: 'مدیریت' },
        { id: 'marketers-list', icon: CompanyFeedback, label: 'لیست بازاریابان', path: `/${url}/marketers-list`, visible: hasRes('MarketersReports'), category: 'مدیریت' },
        { id: 'businesses', icon: businessesManagement, label: 'مدیریت شرکای تجاری', path: `/${url}/businesses`, visible: hasRes('BusinessesManagment'), category: 'مدیریت' },
        { id: 'external-login-test', icon: ExternalLoginPng, label: 'تست اکسترنال لاگین', path: `/${url}/external-login-test`, visible: hasRes('BusinessesManagment'), category: 'مدیریت' },
        { id: 'posts', icon: blogManagement, label: 'مدیریت بلاگ', path: `/${url}/posts`, visible: hasRes('BlogManagment'), category: 'مدیریت' },
        { id: 'seo', icon: seoManagement, label: 'مدیریت سئو', path: `/${url}/seo`, visible: hasRes('SeoManagment'), category: 'مدیریت' },
        { id: 'feedback', icon: CompanyFeedback, label: 'کارتابل نظرات', path: `/${url}/feedback`, visible: hasRes('CompanyFeedback'), category: 'مدیریت' },
        { id: 'slidesManagmanet', icon: EditDesign, label: 'مدیریت اسلایدها', path: `/${url}/slidesManagmanet`, visible: hasRes('AddSliderImage'), category: 'مدیریت' },
        { id: 'whiteLabelSettings', icon: EditDesign, label: 'تنظیمات وایت لیبل', path: `/${url}/whiteLabelSettings`, visible: (businessType === 2 || businessId === 13) && updateBusinessResource && hasRes('EditDesign'), category: 'مدیریت' },
        { id: 'marketerWageSettings', icon: BusinessAdmin, label: 'تنظیمات کارمزد بازاریاب ها', path: `/${url}/marketerWageSettings`, visible: hasRes('BusinessAdmin') && isMarketer, category: 'مدیریت' },
        { id: 'agents-balance', icon: marketerBalanceReport, label: 'گزارش مانده بازاریاب ها', path: `/${url}/agents-balance`, visible: hasRes('MarketersReports') && isMarketer, category: 'مالی' },
        { id: 'marketers-remain-report', icon: accountMarketerTurnover, label: 'گردش حساب یک بازاریاب', path: `/${url}/marketers-remain-report`, visible: hasRes('MarketersReports') && isMarketer, category: 'مالی' },
        { id: 'agents-paid', icon: payMarketers, label: 'پرداخت بازاریاب ها', path: `/${url}/agents-paid`, visible: hasRes('MarketersPaid') && isMarketer, category: 'مالی' },
        { id: 'returned-reports', icon: supportReport, label: 'گزارش عودتی‌ها', path: `/${url}/returned-reports`, visible: hasRes('BusinessDeposit'), category: 'مالی' },
        { id: 'awaiting-returned-reports', icon: supportReport, label: 'گزارش در انتظار عودت مالی', path: `/${url}/awaiting-returned-reports`, visible: hasRes('BusinessDeposit'), category: 'مالی' },
        { id: 'business-rejected-report', icon: rejectedRequests, label: 'درخواست های رد شده', path: `/${url}/business-rejected-report`, visible: hasRes('BusinessRejectedReport'), category: 'فروش' },
        { id: 'business-canceled-report', icon: rejectedRequests, label: 'درخواستهای فسخ شده', path: `/${url}/business-canceled-report`, visible: hasRes('BusinessSaleReport'), category: 'فروش' },
        { id: 'business-under-review-report', icon: requestsInprogress, label: 'درخواست های در حال بررسی', path: `/${url}/business-under-review-report`, visible: hasRes('BusinessUnderReviewReport'), category: 'فروش' },
        { id: 'business-pending-payment', icon: BusinessPendingPayment, label: 'درخواستهای در انتظار پرداخت مابه تفاوت', path: `/${url}/business-pending-payment`, visible: hasRes('BusinessPendingPaymentRequest'), category: 'فروش' },
        { id: 'issue-endorsement-report', icon: sale, label: 'گزارش صدور الحاقیه', path: `/${url}/issue-endorsement-report`, visible: hasRes('BusinessIssueEndorsementReport'), category: 'الحاقیه' },
        { id: 'endorsement-rejected-report', icon: rejectedRequests, label: 'الحاقیه‌های رد شده', path: `/${url}/endorsement/under-review-report`, visible: hasRes('EndorsementRejectedReport'), category: 'الحاقیه' },
        { id: 'endorsement-under-review-report', icon: requestsInprogress, label: 'الحاقیه‌های در حال بررسی', path: `/${url}/endorsement/under-review-report`, visible: hasRes('EndorsementUnderReviewReport'), category: 'الحاقیه' },
        { id: 'endorsement-pending-payment-report', icon: BusinessPendingPayment, label: 'الحاقیه‌های در انتظار پرداخت', path: `/${url}/endorsement/pending-payment-report`, visible: hasRes('EndorsementPendingPaymentReport'), category: 'الحاقیه' },
        { id: 'business-sale-report', icon: sale, label: 'گزارش فروش', path: `/${url}/business-sale-report`, visible: hasRes('BusinessSaleReport'), category: 'گزارشات' },
        { id: 'business-installment-report', icon: installmentImages, label: 'گزارش اقساط', path: `/${url}/business-installment-report`, visible: hasRes('BusinessAdmin'), category: 'گزارشات' },
        { id: 'business-support', icon: supportReport, label: 'گزارش پشتیبانی', path: `/${url}/business-support`, visible: hasRes('BusinessSupportReport'), category: 'گزارشات' },
        { id: 'business-Renewal-report', icon: RenewalReport, label: 'گزارش تمدید', path: `/${url}/business-Renewal-report`, visible: hasRes('BusinessRenewalReport'), category: 'گزارشات' },
        { id: 'company-sale-report', icon: businesscompanySaleReport, label: 'گزارش فروش شرکت', path: `/${url}/company-sale-report`, visible: hasRes('companySaleReport'), category: 'گزارشات' },
        { id: 'page-log-daily-report', icon: supportReport, label: 'گزارش بازدید', path: `/${url}/page-log-daily-report`, visible: hasRes('PageLogDailyReport'), category: 'گزارشات' },
        { id: 'plaque-report', icon: supportReport, label: 'گزارش استعلام پلاک', path: `/${url}/plaque-report`, visible: hasRes('BusinessPlaqueInquiryReport'), category: 'گزارشات' },
        { id: 'white-lable-settelment-fund-report', icon: supportReport, label: 'گزارش تراکنش', path: `/${url}/white-lable-settelment-fund-report`, visible: hasRes('BusinessSaleReport'), category: 'گزارشات' },
        { id: 'business-dashboard', icon: summary, label: 'خلاصه عملکرد سازمان', path: `/${url}/business-dashboard`, visible: hasRes('BusinessSummary'), category: 'گزارشات' },
        { id: 'promoter-users', icon: marketerImg, label: 'جستجوی بازاریاب', path: `/${url}/promoter-users`, visible: hasRes('CRM') && hasRes('Search-Promoter-Users'), category: 'پشتیبانی' },
        { id: 'user-business-report', icon: supportReport, label: 'جست و جوی کاربر', path: `/${url}/user-business-report`, visible: hasRes('UserBusinessReport'), category: 'پشتیبانی' },
        { id: 'call-history', icon: supportReport, label: 'گزارش تماس', path: `/${url}/call-history`, visible: hasRes('UserBusinessReport'), category: 'پشتیبانی' },
        { id: 'my-call-histories', icon: supportReport, label: 'تماس های من', path: `/${url}/my-call-histories`, visible: hasRes('UserBusinessReport'), category: 'پشتیبانی' },
        { id: 'open-tickets', icon: openTickets, label: 'تیکت های باز', path: `/${url}/open-tickets`, visible: hasRes('TicketManagment') && hasTicketingService, category: 'پشتیبانی' },
        { id: 'close-tickets', icon: closeTickets, label: 'تیکت های بسته', path: `/${url}/close-tickets`, visible: hasRes('TicketManagment') && hasTicketingService, category: 'پشتیبانی' },
        { id: 'contact-us', icon: closeTickets, label: 'تماس با ما', path: `/${url}/conact-us`, visible: hasRes('TicketManagment') && hasTicketingService, category: 'پشتیبانی' },
        { id: 'otp-report', icon: supportReport, label: 'گزارش otp', path: `/${url}/otp-report`, visible: hasRes('OTPReport'), category: 'پشتیبانی' },
        { id: 'receipts', icon: receiptIcon, label: 'فاکتورها', path: `/${url}/receipts`, visible: hasRes('BusinessSaleReport'), category: 'فاکتورها' },
        { id: 'notifications', icon: notifications, label: 'اعلان ها', path: `/${url}/notifications`, visible: true, category: 'سایر' },
    ];

    const visibleItems = toolItems.filter(item => item.visible);

    const categoryFilteredItems = selectedCategory === 'all'
        ? visibleItems
        : visibleItems.filter(item => item.category === selectedCategory);

    const term = searchTerm.trim().toLowerCase();
    const searchedItems = term
        ? categoryFilteredItems.filter(item => item.label.toLowerCase().includes(term))
        : categoryFilteredItems;

    const quickAccessItems = visibleItems.filter(item => isQuickAccess(username, item.id));
    const [showAllQuickAccess, setShowAllQuickAccess] = React.useState(false);

    const isCompact = isMobile || isTablet;
    const activeGridCols = isCompact ? 2 : gridCols;
    const gridColClass = `col-6 col-sm-6 ${GRID_COLS_TO_LG_CLASS[activeGridCols]}`;
    const QUICK_ACCESS_COLLAPSED_COUNT = 6;
    const displayedQuickAccessItems = showAllQuickAccess
        ? quickAccessItems
        : quickAccessItems.slice(0, QUICK_ACCESS_COLLAPSED_COUNT);
    const hiddenQuickAccessCount = quickAccessItems.length - displayedQuickAccessItems.length;

    return (
        <div className="main-contents">
            <div className={(isMobile || isTablet) ? "my-3" : "mb-3"}></div>

            {quickAccessItems.length > 0 && (
                <div className="quick-access-section mb-4">
                    <h5 className="quick-access-title">دسترسی سریع</h5>
                    <div className="row px-0 lg-p-4">
                        {displayedQuickAccessItems.map(item => (
                            <ToolCard
                                key={`qa-${item.id}`}
                                item={item}
                                isPinned={true}
                                onTogglePin={() => toggleQuickAccess(username, item.id)}
                                onNavigate={() => handlePageTitle(item.label)}
                                colClass={gridColClass}
                            />
                        ))}
                    </div>
                    {quickAccessItems.length > QUICK_ACCESS_COLLAPSED_COUNT && (
                        <div className="text-center">
                            <button
                                type="button"
                                className="quick-access-toggle-btn"
                                onClick={() => setShowAllQuickAccess(prev => !prev)}
                            >
                                {showAllQuickAccess ? 'نمایش کمتر' : `نمایش بیشتر (${toPersianDigits(hiddenQuickAccessCount)})`}
                            </button>
                        </div>
                    )}
                    <hr className="quick-access-divider" />
                </div>
            )}

            <div className="row px-0 lg-p-4">
                {searchedItems.map(item => (
                    <ToolCard
                        key={item.id}
                        item={item}
                        isPinned={isQuickAccess(username, item.id)}
                        onTogglePin={() => toggleQuickAccess(username, item.id)}
                        onNavigate={() => handlePageTitle(item.label)}
                        colClass={gridColClass}
                    />
                ))}
            </div>
        </div>
    )
}
export default MainContent;
